import { useState } from "react";
import type { ModeloDaFace } from "@bookdental/schemas";
import { modeloDoPlano } from "@/components/face/desenhos";
import type { ModoDoDesenho } from "./DesenhoDoPlano";
import type { ItemDoPlanoTela } from "./ItensDoPlano";

const HOF = "HARMONIZACAO_OROFACIAL";

/**
 * Dentes ou Face no editor do plano — a face fica sempre disponível, com ou sem Harmonização
 * Orofacial na clínica. Escolher procedimento de HOF ou um item só de face abre o rosto, item só de
 * dentes volta pra arcada. O modelo do desenho segue o sexo do paciente até alguém trocar.
 */
export function useModoDoDesenho(
  plano: { modeloDaFace: ModeloDaFace | null } | undefined,
  sexo: string | null | undefined,
  salvarModelo: ((m: ModeloDaFace) => void) | null,
) {
  const [modo, setModo] = useState<ModoDoDesenho>("DENTES");
  const [modeloLocal, setModeloLocal] = useState<ModeloDaFace | null>(null);

  return {
    modo,
    setModo,
    // Plano recém-criado ainda não gravou o modelo escolhido antes do primeiro item: vale o local.
    modelo: modeloDoPlano(plano?.modeloDaFace ?? modeloLocal, sexo),
    mudarModelo: (m: ModeloDaFace) => (salvarModelo ? salvarModelo(m) : setModeloLocal(m)),
    seguirItem: (i: ItemDoPlanoTela) => {
      if (i.marcacoes.length && !i.dentes) setModo("FACE");
      else if (i.dentes && !i.marcacoes.length) setModo("DENTES");
    },
    seguirProcedimento: (p: { especialidade: { code?: string } } | null) => {
      if (p?.especialidade.code === HOF) setModo("FACE");
    },
  };
}
